import type { InputHTMLAttributes, ReactNode } from "react";
import { cx } from "./cx";

export interface ToggleProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: ReactNode;
}

/** Switch — a checkbox with role="switch" semantics and track/thumb chrome. */
export function Toggle({ label, className, disabled, ...rest }: ToggleProps) {
  return (
    <label className={cx("pz-toggle", disabled && "pz-check--disabled", className)}>
      <input type="checkbox" role="switch" className="pz-toggle__input" disabled={disabled} {...rest} />
      {label != null && <span>{label}</span>}
    </label>
  );
}
